import React, { useState, useEffect } from 'react';
import { InputGroup, FileInput, Checkbox } from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';
import axios from 'axios';

import auth from '../../auth';

import Loading from '../../components/Loading/Loading';

export default function EditContributeDialog({onClose, scenario, onFilesDeleted}) {
    
    const [state, setState] = useState({
        title: "", selectedCategories: [], description: "", files: null, thumbnail: null, 
        categories: []
    });
    const [miscFiles, setMiscFiles] = useState(scenario.filesURL);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [isMaster, setIsMaster] = useState(false);
    const [deletingFiles, setDeletingFiles] = useState(false);
    
    async function handleSubmit() {
        try {
            if(!state.title) {
                return setError("Title is missing")
            }
            if(state.title.length < 3) {
                return setError("Title must be at least 3 characters")
            }
            if(state.selectedCategories.length === 0) {
                return setError("No category selected")
            }
            if(!state.description) {
                return setError("Description is missing")
            }
            console.log("Submitted", {...state})
            setSubmitting(true)
            const data = new FormData()
            data.append("scenario", scenario)
            data.append("title", state.title)
            data.append("description", state.description)
            data.append("categories", JSON.stringify(state.selectedCategories))
            if(state.files) {
                console.log("FILE", state.files[0])
                data.append("file", state.files[0])
            }
            if(state.thumbnail) {
                console.log("THUMBNAIL", state.thumbnail)
                data.append("thumbnail", state.thumbnail)
            }
            const response = await axios.patch(`/api/scenarios/contribute/${scenario._id}`, data, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            })
            if(response.status < 400) {
                return onClose()
            }
            setError(response.data.error)
            setSubmitting(false)
        } catch (err) {
            console.error(err)
            setSubmitting(false)
        }
    }
    
    useEffect(()=>{
        console.log("Given scenario", scenario);
        const {title, description, categories} = scenario;
        setState((prevState)=>({...prevState, title, description, selectedCategories: categories }));
        if(auth.can('scenario-master')) {
            setIsMaster(true);
        }
        (async ()=>{
            try {
                const response = await axios.get('/api/category', {
                    headers: {
                        'Authorization': window.localStorage.getItem("token")
                    }
                })
                setState((prevState)=>({...prevState, categories: response.data.categories}));
            } catch (err) {
                console.error(err)
            } finally {
                setLoading(false);
            }
        })();
    }, []);
    
    const handleDeleteFiles = async () => {
        setDeletingFiles(true);
        try {
            await axios.delete(`/api/scenarios/contribute/${scenario._id}/files`, {
                headers: {
                    'Authorization': window.localStorage.getItem("token")
                }
            });
            setMiscFiles(null);
            onFilesDeleted();
        } catch (err) {
            console.error(err);
        } finally {
            setDeletingFiles(false);
        }
    }
    
    return (
        loading?
        <Loading />
        :
        <div className="column" style={{padding: '20px 20px 0px 20px'}}>
                {
                    error?
                    <div className="row centered" style={{color: 'red', marginBottom: 8}}>
                        {error}
                    </div>
                    :
                    null
                }
            <InputGroup
                // leftElement={<Icon icon="tag" />}
                onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, title: event.target.value}))}}
                placeholder="Title"
                value={state.title}
            />
            <span style={{padding: '10px'}}>
            {
                state.categories.filter((category)=>!category.parent).map((category)=>(
                    <div style={{width: '200px', marginBottom: 30}}>
                        <Checkbox 
                            key={category._id}
                            label={category.name} 
                            checked={state.selectedCategories.includes(category._id)} 
                            onChange={
                                (event)=>{
                                    event.persist();
                                    event.target.checked? 
                                    setState((prevState)=>({
                                        ...prevState,
                                        selectedCategories: prevState.selectedCategories.concat(category._id)
                                // to select parent cat as well: selectedCategories: prevState.selectedCategories.concat(category._id, ...prevState.categories.filter((cat)=>cat.parent === category._id).map((cat)=>cat._id))
                                
                                    })) 
                                    : 
                                    setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id)})) 
                                // to select parent cat as well: setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id && prevState.categories.find((c)=>c._id === cat).parent !== category._id)})) 
                                
                                }
                            }
                        />
                        <div style={{paddingLeft: '15px'}}>
                        {
                            state.categories
                            .filter((cat)=>cat.parent === category._id)
                            .map((cat)=>(
                                <Checkbox 
                                    key={cat._id}
                                    label={cat.name} 
                                    checked={state.selectedCategories.includes(cat._id)} 
                                    onChange={
                                        (event)=>{
                                            event.persist();
                                            event.target.checked? 
                                            setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.concat(cat._id, cat.parent)})) 
                                            
                                            : 
                                            setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((word)=> word !== cat._id)})) 
                                        }
                                    }
                                />  
                            ))
                        }
                        </div>
                    </div>
                ))
            }
            </span>
            <InputGroup
                // leftElement={<Icon icon="tag" />}
                onChange={(event)=>{event.persist(); setState((prevState)=>({...prevState, description: event.target.value}))}}
                placeholder="Description"
                value={state.description}
                style={{marginBottom: 3}}
            />
            <div className="row" style={{marginBottom: 3, marginRight: 10}}>
                {
                    miscFiles &&
                    <button onClick={()=>window.open(miscFiles, "_blank")} className="btn btn-primary" style={{width: 100}}>Current Files</button>   
                }
                {
                    isMaster && 
                    <React.Fragment>
                        <FileInput
                            text={state.files && state.files.length? state.files[0].name : "Choose file..."}
                            inputProps={{accept: '.zip,.tar,.tar.gz,.7z'}}
                            buttonText={"Select"}
                            onInputChange={(event)=>{event.persist(); console.log(event.target.files); setState((prevState)=>({...prevState, files: event.target.files}))}}
                        />
                        {
                            miscFiles &&
                            <button disabled={deletingFiles} onClick={handleDeleteFiles} className="btn btn-primary">Remove Files</button>
                        }
                    </React.Fragment>
                }
            </div>
            <div>
                {
                    scenario.thumbnailURL &&
                    <img src={scenario.thumbnailURL} style={{width: 100, maxHeight: 400}} />
                }
                {
                    isMaster &&
                    <FileInput
                        text={state.thumbnail && state.thumbnail? state.thumbnail.name : "Choose thumbnail..."}
                        inputProps={{accept: 'image/*'}}
                        buttonText={"Select"}
                        onInputChange={(event)=>{event.persist(); console.log(event.target.files); setState((prevState)=>({...prevState, thumbnail: event.target.files[0]}))}}
                    />
                }
            </div>
            <button className={`btn btn-primary`} style={{marginTop: 10}} onClick={handleSubmit} disabled={submitting}>
              <i className="fas fa-fw fa-share-alt"/> Edit Contribution
            </button>
        </div>
    )
    
}